import React, { Fragment } from "react";
import Header from "../components/Header";
import ServiceDetails from "../templates/CentreDetails";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";

const PageCentreDetails = () => {
  return (
    <Fragment>
      <Header />
      <ServiceDetails />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default PageCentreDetails;
